import { connect } from 'react-redux';
import AffiliateSetting from '../component/AffilateSetting';
import actions from '../redux/actions/affiliate';

const mapStateToProps = (state) => ({
  setting: state.affiliate.setting || [],
  pubkey: state.user.session.pubkey,
});

const mapDispatchToProps = (dispatch) => ({
  getAffiliateSetting: (params, callback) => {
    dispatch(actions.getAffiliateSetting(params, callback));
  },
  postAffiliateSetting: (params, callback) => {
    dispatch(actions.postAffiliateSetting(params, callback));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AffiliateSetting);
